import { configureStore } from "@reduxjs/toolkit";
import counterReducer from "../state/counter/Counter"
import cartReducer from "../state/cart/CartSlice"

export default configureStore({
    reducer:{
        counter: counterReducer,
        cart: cartReducer
    }
})